import React from 'react';
import './_styles_/WarningNotification.css';
import { notificationType } from '../../types';
import Notification from './Notification';

WarningNotification.propTypes = {
    notification: notificationType.isRequired,
};

function WarningNotification(props) {
    const { notification } = props;
    return (
        <Notification outerClass="warning-notification" buttonClass="button-black-text" notification={notification} />
    );
}

export default WarningNotification;
